import type { LogSessionMetadata } from '../types';

function formatNumber(value: number): string {
  return Number(value.toFixed(2)).toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
}

export function formatSessionSummary(
  session: Pick<LogSessionMetadata, 'duration' | 'sampleCount' | 'sampleRateHz'>,
): string {
  const duration = Math.max(0, session.duration);
  const totalSeconds = Math.round(duration);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds - hours * 3600 - minutes * 60;
  const durationParts = [
    hours > 0 ? `${hours}h` : null,
    minutes > 0 ? `${minutes}m` : null,
    `${seconds}s`,
  ].filter(Boolean);
  return `${durationParts.join(' ')} (${session.sampleCount.toLocaleString('en-US')} samples @${formatNumber(session.sampleRateHz)}hz)`;
}

export function estimateSampleRate(time: ArrayLike<number>): number {
  const intervals: number[] = [];
  for (let index = 1; index < time.length; index += 1) {
    const interval = time[index] - time[index - 1];
    if (Number.isFinite(interval) && interval > 0) intervals.push(interval);
  }
  if (intervals.length === 0) return 0;

  intervals.sort((left, right) => left - right);
  const middle = Math.floor(intervals.length / 2);
  const median = intervals.length % 2 === 0
    ? (intervals[middle - 1] + intervals[middle]) / 2
    : intervals[middle];
  return 1 / median;
}
